import React from 'react';

abstract class Component<Props = Record<string, unknown>, State = Record<string, unknown>> extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {} as any;
    }

    public override async setState<K extends keyof State>(state: Pick<State, K>): Promise<void> {
        if (arguments.length === 2) {
            // eslint-disable-next-line prefer-rest-params
            super.setState(state, arguments[1]);
        } else {
            await new Promise<void>((resolve) => {
                super.setState(state, () => {
                    resolve();
                });
            });
            return;
        }
    }
    public async setStatePromised<K extends keyof State>(
        updateFunction: (prevState: Readonly<State>) => Pick<State, K> | State | null,
    ): Promise<void> {
        return new Promise((resolve) => {
            super.setState(updateFunction, () => {
                resolve();
            });
        });
    }
}

export { Component };
